var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.url)?_c('a',{staticClass:"mg-button mg-button--large mg-button--accent md-chart-wrapper__download no-print",attrs:{"href":_vm.url,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v("\n    Download Data\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ff0258a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/vue-components/data-download-button.vue
// module id = 387
// module chunks = 0